module.exports = __webpack_public_path__ + "static/img/img_welecome.1f830718.png";